"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/message/style");
var _message2 = _interopRequireDefault(require("antd/lib/message"));
var _react = _interopRequireWildcard(require("react"));
var _loadJs = require("../../utils/loadJs");
var _captcha = require("../../consts/captcha");
var _jsonp = _interopRequireDefault(require("jsonp"));
var _gyyx = _interopRequireDefault(require("./gyyx"));
var _gyyxSimple = _interopRequireDefault(require("./gyyxSimple"));
var _gywd = _interopRequireDefault(require("./gywd"));
var _tencent = _interopRequireDefault(require("./tencent"));
var _imageOrderClick = _interopRequireDefault(require("./imageOrderClick"));
require("./style.css");
var _login = require("../../servers/login");
var _utils = require("../../utils");
var _consts = require("../../consts");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Index = function Index(props) {
  var bId = props.bId,
    visible = props.visible,
    onSubmit = props.onSubmit,
    errorHandler = props.errorHandler,
    onClose = props.onClose,
    getCaptchaType = props.getCaptchaType,
    _props$refreshCaptcha = props.refreshCaptcha,
    refreshCaptcha = _props$refreshCaptcha === void 0 ? 0 : _props$refreshCaptcha;
  // 验证码
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    captchaData = _useState2[0],
    setCaptchaData = _useState2[1];
  // 当前验证码对象
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    captchaItem = _useState4[0],
    setCaptchaItem = _useState4[1];
  // 平衡票据code
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    balanceCode = _useState6[0],
    setBalanceCode = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    publicIp = _useState8[0],
    setPublicIp = _useState8[1];
  /**
   * 加载验证码
   */
  var getCaptcha = function getCaptcha() {
    (0, _loadJs.loadJs)({
      src: _captcha.CAPTCHA_URL,
      cb: function cb() {
        if (window.callback_captcha) {
          var res = window.callback_captcha;
          setCaptchaData(res);
        }
      }
    }).catch(function () {
      _message2.default.error('加载验证码文件失败，请刷新页面');
    });
  };
  var handleInit = function handleInit() {
    if (!captchaData[bId]) {
      _message2.default.error('没有找到对应的bid值，请到配置中心确认');
      return;
    }
    if (captchaData[bId].balance !== 1) {
      setCaptchaItem(captchaData[bId]);
      getCaptchaType && getCaptchaType(captchaData[bId].type);
      return;
    }
    // 获取票据地址
    var balanceUrl = "".concat(captchaData[bId].gy_balance_url.split(':')[1], "?bid=").concat(bId, "&r=").concat(Math.random());
    if (captchaData[bId].gy_balance_url.indexOf('validation2') === -1) {
      (0, _jsonp.default)(balanceUrl, {
        param: 'callback'
      }, function (error, data) {
        if (data.isSuccess) {
          updateCaptchaState(data.data);
        }
      });
    } else {
      (0, _login.getCaptchaImg)({
        url: balanceUrl
      }).then(function (res) {
        if (res.success) {
          updateCaptchaState(res.data);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  };
  var updateCaptchaState = function updateCaptchaState(data) {
    var _captchaData$bId;
    setBalanceCode(data);
    setCaptchaItem(captchaData[bId]);
    getCaptchaType === null || getCaptchaType === void 0 ? void 0 : getCaptchaType(captchaData[bId].type);
    if ((_captchaData$bId = captchaData[bId]) === null || _captchaData$bId === void 0 ? void 0 : _captchaData$bId.public_sign) {
      (0, _jsonp.default)("".concat(_consts.VALIDATION_2_URL, "/stun/url?bid=").concat(bId), {
        param: 'callback'
      }, function (error, data) {
        if (data.isSuccess) {
          (0, _utils.getPublicIP)(data.data).then(function (ip) {
            ip && setPublicIp(ip);
          });
        }
      });
    }
  };
  (0, _react.useEffect)(function () {
    getCaptcha();
  }, []);
  (0, _react.useEffect)(function () {
    if (0 < Object.keys(captchaData).length && (visible || refreshCaptcha !== 0)) {
      handleInit();
    }
  }, [captchaData, visible, refreshCaptcha]);
  var handleInitFunc = function handleInitFunc() {
    handleInit();
  };
  return visible ? /*#__PURE__*/_react.default.createElement("div", null, captchaItem.type === _captcha.CAPTCHA_TYPE.gycl && /*#__PURE__*/_react.default.createElement(_imageOrderClick.default, _objectSpread({
    balanceCode: balanceCode,
    handleInitFunc: handleInitFunc,
    captchaItem: captchaItem,
    publicIp: publicIp
  }, props)), captchaItem.type === _captcha.CAPTCHA_TYPE.gy && captchaItem.gy_kind === 1 && /*#__PURE__*/_react.default.createElement(_gyyx.default, _objectSpread({
    balanceCode: balanceCode,
    handleInitFunc: handleInitFunc,
    captchaItem: captchaItem,
    publicIp: publicIp
  }, props)), captchaItem.type === _captcha.CAPTCHA_TYPE.gy && captchaItem.gy_kind === 0 && /*#__PURE__*/_react.default.createElement(_gyyxSimple.default, _objectSpread({
    captchaItem: captchaItem,
    handleInitFunc: handleInitFunc,
    balanceCode: balanceCode,
    publicIp: publicIp
  }, props)), captchaItem.type === _captcha.CAPTCHA_TYPE.gywd && /*#__PURE__*/_react.default.createElement(_gywd.default, _objectSpread({
    balanceCode: balanceCode,
    handleInitFunc: handleInitFunc,
    captchaItem: captchaItem,
    publicIp: publicIp
  }, props)), captchaItem.type === _captcha.CAPTCHA_TYPE.tencent && /*#__PURE__*/_react.default.createElement(_tencent.default, _objectSpread({
    handleInitFunc: handleInitFunc,
    balanceCode: balanceCode,
    captchaItem: captchaItem,
    errorHandler: errorHandler,
    publicIp: publicIp
  }, props))) : null;
};
var _default = Index;
exports.default = _default;